module.exports = __webpack_public_path__ + "static/media/bye.ce467dd0.jpg";